import { useEffect, useState } from "react";
const useDebounceValue = (val, delay)=>{
    const [debounceVal, setDebounceVal] = useState(val);
    useEffect(()=>{
        const handler = setTimeout(()=>{
            setDebounceVal(val);
        }, delay);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        val,
        delay
    ]);
    return debounceVal;
};
export { useDebounceValue };
